import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function WebsitePagesPage(){return <ExtendedModulePage moduleKey="website-pages"/>}
